export const FeatureManagementRoute = {
  FeatureSettings: 'feature-settings'
} as const;

export type FeatureManagementRoute =
  (typeof FeatureManagementRoute)[keyof typeof FeatureManagementRoute];

export type FeatureManagementParam = {
  [FeatureManagementRoute.FeatureSettings]: undefined;
};
